import React from 'react';
import { string, oneOf } from 'prop-types';
import { Star } from '@magalu/stereo-ui-icons';
import { Container, Title } from './label-score.styles';

function LabelScore({
  label,
  type
}) {
  const stars = Array.from(Array(5).keys());
  const size = type === 'normal' ? '30px' : '40px';
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Title, {
    type: type,
    "data-testid": "title"
  }, label), /*#__PURE__*/React.createElement("ul", null, stars.map(i => /*#__PURE__*/React.createElement(Star, {
    key: `star-${i}`,
    color: "#FFCC03",
    width: size,
    height: size
  }))));
}

LabelScore.defaultProps = {
  size: '30px',
  type: 'normal'
};
process.env.NODE_ENV !== "production" ? LabelScore.propTypes = {
  label: string,
  size: string,
  type: oneOf(['normal', 'big'])
} : void 0;
export default LabelScore;